import React from 'react'
import CreatableSizeSelect from '../CreatableSizeSelect'

const TyreProfileField = ({ input }) => (
  <CreatableSizeSelect onChange={input.onChange} min={40} max={100} step={5} />
)

export default TyreProfileField
